import formsBackendClient, { ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';
import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/questionnaire-templates/linked-field-details']['PUT'];
type Input = ThisApi['body'];

const getLinkedFieldKeyDetails = async ({ linkedFieldKeys, questionnaireTemplateId }: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>('/questionnaire-templates/linked-field-details');
  const data = await formsBackendClient.put(path, {
    linkedFieldKeys,
    questionnaireTemplateId,
  });
  return data.data;
};

export default getLinkedFieldKeyDetails;
